import { AxiosRequestHeaders } from 'axios';
import {
  KeyValueMap,
  EntryProps,
  PaginationQueryOptions,
  QueryParams,
} from '../../commonTypes';
import {
  CreateStopWordProps,
  RestEndpoint,
  UpdateStopWordProps,
} from './types';
import { AxiosInstance } from '../../commonTypes';
import * as raw from './raw';
import { DEFAULT_QUERY } from '../constants';

const BASE_URL = '/stop-words';

export const get: RestEndpoint<'StopWord', 'get'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  params: { id: string | number },
  headers?: AxiosRequestHeaders
) => {
  return raw.get<EntryProps<T> | null>(http, `${BASE_URL}/${params.id}`, {
    headers: { ...headers },
    params: {...DEFAULT_QUERY}
  });
};

export const getMany: RestEndpoint<'StopWord', 'getMany'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  params: QueryParams<PaginationQueryOptions>,
  headers?: AxiosRequestHeaders
) => {
  return raw.get<EntryProps<T, true>>(http, `${BASE_URL}`, {
    headers: { ...headers },
    params: params.query,
  });
};

export const create: RestEndpoint<'StopWord', 'create'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  rawData: CreateStopWordProps,
  headers?: AxiosRequestHeaders
) => {
  return raw.post<EntryProps<T> | null>(http, `${BASE_URL}`, rawData, {
    headers: { ...headers },
  });
};

export const update: RestEndpoint<'StopWord', 'update'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  params: { id: string | number },
  rawData: UpdateStopWordProps,
  headers?: AxiosRequestHeaders
) => {
  return raw.put<EntryProps<T> | null>(
    http,
    `${BASE_URL}/${params.id}`,
    rawData,
    {
      headers: { ...headers },
    }
  );
};

export const del: RestEndpoint<'StopWord', 'del'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  params: { id: string | number },
  headers?: AxiosRequestHeaders
) => {
  return raw.del<T>(http, `${BASE_URL}/${params.id}`, {
    headers: { ...headers },
  });
};
